import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardTitle,
  CardBody,
  CardActions,
  CardSubtitle,
} from "@progress/kendo-react-layout";
import {
  dateFormat,
  redirectHome,
  errorSaveMessage,
  SuccessSaveMessage,
  undoMessage1,
  undoMessage2,
} from "../../services/shareconstant";
import { Notification } from "@progress/kendo-react-notification";
import { STATUS } from "../../model/constants";
import { PostSave } from "../../services/useFetch";
import { urlEnrollmentSave } from "../../services/serviceURLs";
import Spinner from "../Spinner";
import CoverageCard from "./CoverageCard";
import CustomButtonToolTip from "./CustomButtonToolTip";
import { Tooltip } from "@progress/kendo-react-tooltip";

export default function EOIPendingNewElections(props) {
  const [openCancelForm, setOpenCancelForm] = useState(false);
  const [cancelCard, setCancelCard] = useState({});
  const [status, setStatus] = useState(STATUS.IDLE);
  const [saveError, setSaveError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [electionMsg, setElectionMsg] = useState(``);
  const history = useHistory();

  const modifyClick = (card) => {
    history.push({
      pathname: `/plan`,
      state: { plan: card, electionDates: props.electionDates },
    });
  };
  const EOIClick = (card) => {
    history.push({
      pathname: `/eoirequest`
    });
  };
  const cancelClick = (card) => {
    setCancelCard(card);
    setOpenCancelForm(true);
  };

  const toggleDialog = () => {
    setOpenCancelForm(!openCancelForm);
  };

  const onCancelConfirm = async () => {
    try {
      setOpenCancelForm(false);
      setCancelCard({});
      setStatus(STATUS.SUBMITTING);
      const saveElection = {
        electionType: `CancelPending`,
        insuranceElectionID: cancelCard.insuranceElectionID,
        insuranceID: cancelCard.insuranceID,
      };
      const saveresponse = await PostSave(
        `${urlEnrollmentSave}`,
        `POST`,
        saveElection
      );
      setSaveError(null);
      if (saveresponse.ok) {
        const electionresult = await saveresponse.json();
        setElectionMsg(electionresult.Message);
        setSuccess(true);
        setError(false);
        setStatus(STATUS.COMPLETED);
      } else {
        throw saveresponse;
      }
    } catch (e) {
      setSaveError(e.statusText);
      setStatus(STATUS.ERROR);
      setSuccess(false);
      setError(true);
    }
  };

  function handleCloseDialog() {
    history.push(redirectHome());
  }

  return (
    <>
      {status === STATUS.SUBMITTING && <Spinner />}

      {(success || error) && (
        <Dialog onClose={handleCloseDialog}>
          {success && electionMsg === "Cancelled" && (
            <Notification
              type={{ style: "success", icon: true }}
              closable={false}
            >
              <span>{SuccessSaveMessage}</span>
            </Notification>
          )}
          {error && (
            <Notification
              type={{ style: "error", icon: true }}
              closable={false}
            >
              <span>
                {errorSaveMessage} {saveError}
              </span>
            </Notification>
          )}
          <DialogActionsBar>
            <button className="k-button" onClick={handleCloseDialog}>
              OK
            </button>
          </DialogActionsBar>
        </Dialog>
      )}

      {openCancelForm && (
        <Dialog
          className="confirmUndo"
          title={"Confirm Undo"}
          onClose={toggleDialog}
        >
          <p>{undoMessage1}</p>
          <CardSubtitle>
            {cancelCard.insurancePlanTypeDescription}.
          </CardSubtitle>
          <p>{undoMessage2} </p>
          <DialogActionsBar>
            <Button themeColor="primary" onClick={onCancelConfirm}>
              {" "}
              Confirm
            </Button>
            <Button themeColor="secondary" onClick={toggleDialog}>
              {" "}
              Cancel
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}

      {props.EOIpendingNewElections.map((card, index) => {
        return (
          <div key={index} className="card-items">
            <Card>
              <div>
                <CardBody>
                  {/* <CardSubtitle> Pending New Election - Unsubmitted new election - ALPAIN-60</CardSubtitle> */}
                  <br/>
                  <CardTitle>
                  {card.insuranceID > 0 ? (
                    <p className="text-ellipsis description-block">
                      {card.insurancePlanTypeDescription} ID #{card.insuranceID}
                    </p>
                  ) : (
                    <p className="text-ellipsis description-block">
                      {card.insurancePlanTypeDescription}
                    </p>
                  )}
                    {card.nonContributoryOptIn === true &&
                    JSON.parse(localStorage.getItem("showApprentice")) === true
                      ? ` (Apprentice)`
                      : null}
                  </CardTitle>                 
                  <p className="startDate-label">
                    Start Date:{" "}
                    <span className="startDate-new">
                      {dateFormat(card.startDate)}
                    </span>
                  </p>
                  <CoverageCard card={card} />
                </CardBody>
                <CardActions>
                  <div className="eoi-action">
                      {card.status==='EOI Pending' ? (
                          <Button
                            themeColor="primary"
                            fillMode="flat"
                            onClick={() => EOIClick(card)}
                          >
                            {" "}
                            EOI Pending{" "}
                          </Button>
                      ):null}  
                  </div>
                  <div className="main-action">
                    {" "}                
                    {card.insuranceID > 0 && card.insurancePlanTypeName!=="MLUM" && card.insurancePlanTypeName!=="MLUS" ? (    
                    <Button
                      themeColor="primary"
                      fillMode="flat"
                      onClick={() => modifyClick(card)}
                    >
                      {" "}
                      Modify{" "}
                    </Button>
                    ):<Tooltip
                      content={(prop) => (
                        <CustomButtonToolTip/>
                      )}
                    anchorElement="target"
                    position="bottom"
                  > <span className="k-button k-button-md k-primary k-flat k-i-information disabledControlButton"
                  title="Modify">Modify</span>
                    </Tooltip>}
                    {card.status!=='EOI Pending' ? (
                        <Button
                           themeColor="primary"
                           fillMode="flat"
                           onClick={() => cancelClick(card)}
                         >
                           Undo{" "}
                        </Button> 
                      ):null}  
                   
                  </div>
                </CardActions>
              </div>
            </Card>
          </div>
        );
      })}
    </>
  );
}
